// app/javascript/modules/admissoes/dependentes_docs.js

export function initDependentesDocs($form, h) {
  const { hide, show, parseDateSmart, calcAge } = h
  const ns = ".admissaoDependentes"

  // --- Controle de "Possui Dependentes?" ---

  const CAMPOS_DEPENDENTE_REQUIRED = [
    "#params_nome_dependente",
    "#params_data_nascimento_dependente",
    "#params_grau_parentesco_dependente",
    "#params_cpf_dependente",
  ]

  function setRequiredDependente(required) {
    CAMPOS_DEPENDENTE_REQUIRED.forEach(sel => {
      const $el = $form.find(sel)
      if (!$el.length) return
      if (required) {
        $el.attr("required", "required").attr("aria-required", "true")
      } else {
        $el.removeAttr("required").removeAttr("aria-required")
      }
    })
  }

  function syncPlanoDependente() {
    // CPF é sempre obrigatório quando há dependente; nada a fazer aqui
  }

  function syncPossuiDependentes() {
    const val = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    const $conteudo = $form.find("#secao-dependentes-conteudo")

    if (val === "Sim") {
      $conteudo.show()
      setRequiredDependente(true)
      syncPlanoDependente()
      syncDocsPrimeiroDependente()
      // Restaura estado correto da pensão ao reabrir a seção
      syncPensaoAlimenticia()
    } else {
      $conteudo.hide()
      setRequiredDependente(false)
      $form.find("#docs-primeiro-dependente").hide()
      // Remove required e desabilita campos de pensão
      $form.find('[data-pensao-campo="true"]').prop("disabled", true).prop("readonly", true)
        .removeAttr("required").removeAttr("aria-required")
      // Remove required de TUDO dentro da seção oculta (inclui plano_saude_dependente, etc.)
      $conteudo.find('input, select, textarea')
        .removeAttr("required").removeAttr("aria-required")
    }
  }

  // --- Docs do primeiro dependente (Filho ou Filho PCD, com docs condicionais por idade) ---

  function syncDocsPrimeiroDependente() {
    const possuiDep = $form.find('input[name="params[possui_dependentes]"]:checked').val()
    if (possuiDep !== "Sim") {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    const grau = $form.find("#params_grau_parentesco_dependente").val()
    const isFilho = grau === "Filho" || grau === "Filho PCD"

    if (!isFilho) {
      $form.find("#docs-primeiro-dependente").hide()
      return
    }

    // Seção de docs sempre visível para filho
    $form.find("#docs-primeiro-dependente").show()

    const dn = parseDateSmart($form.find("#params_data_nascimento_dependente").val())
    const idade = dn ? calcAge(dn) : null

    // Cartão de vacina: até 6 anos
    $form.find("#docs-cartao-vacina-primeiro").toggle(idade !== null && idade <= 6)

    // Declaração escolar + Certidão escolar: 7 a 14 anos
    const mostra7a14 = idade !== null && idade >= 7 && idade <= 14
    $form.find("#docs-declaracao-escolar-primeiro").toggle(mostra7a14)
    $form.find("#docs-certidao-escolar-primeiro").toggle(mostra7a14)

    // Obrigatório quando visível
    const setFileReq = (divId, req) => {
      const $fi = $form.find(`${divId} input[type="file"]`)
      if (!$fi.length) return
      const $widget = $fi.closest('[data-controller~="crud--upload-arquivo"], [data-controller~="crud--upload-simples"]')
      const jaAnexado = !!$widget.find('a[target="_blank"]').length
      req && !jaAnexado ? $fi.attr("required", "required") : $fi.removeAttr("required")
    }
    setFileReq("#docs-declaracao-escolar-primeiro", mostra7a14)
    setFileReq("#docs-certidao-escolar-primeiro", mostra7a14)
  }

  // --- Pensão alimentícia ---

  const PENSAO_REQUIRED = [
    "#params_nome_pensionista",
    "#params_telefone_pensionista",
    "#params_numero_oficio",
  ]

  function syncPensaoAlimenticia() {
    const val     = $form.find('input[name="params[pensao_alimenticia]"]:checked').val()
    const $secao  = $form.find("#secao-pensao-campos")
    const $campos = $form.find('[data-pensao-campo="true"]')

    if (val === "Sim") {
      $secao.show()
      $campos.prop("disabled", false).prop("readonly", false)
        .removeAttr("required").removeAttr("aria-required")
      PENSAO_REQUIRED.forEach(sel => {
        const $el = $form.find(sel)
        if ($el.length) $el.attr("required", "required").attr("aria-required", "true")
      })
      // Documento da pensão: obrigatório se ainda não anexado
      const $docWidget = $secao.find('[data-controller~="crud--upload-arquivo"]').last()
      const $docFile   = $docWidget.find('input[type="file"]')
      const jaAnexado  = !!$docWidget.find('a[target="_blank"]').length
      if ($docFile.length && !jaAnexado) $docFile.attr("required", "required")
    } else {
      $secao.hide()
      $campos.prop("disabled", true).prop("readonly", true)
        .removeAttr("required").removeAttr("aria-required")
      // Remove required do documento ao ocultar
      $secao.find('[data-controller~="crud--upload-arquivo"] input[type="file"]').removeAttr("required")
    }
  }

  // CPF do dependente adicional é sempre obrigatório
  function syncPlanoDepAdicional($item) {
    const $cpf = $item.find('input[name*="cpf_dependente"]')
    if (!$cpf.length) return
    $cpf.attr("required", "required").attr("aria-required", "true")
  }

  // --- Bind events ---

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[possui_dependentes]"]', syncPossuiDependentes)
  $form.on(`change${ns}`, "#params_grau_parentesco_dependente, #params_data_nascimento_dependente", syncDocsPrimeiroDependente)
  $form.on(`change${ns}`, 'input[name="params[plano_saude_dependente]"], input[name="params[plano_odontologico_dependente]"]', syncPlanoDependente)
  // delegação para dependentes adicionais (gerados dinamicamente em #novos_campos)
  $form.on(`change${ns}`, 'input.dep-plano-radio', function () {
    syncPlanoDepAdicional($form.constructor(this).closest('.dependente-item'))
  })
  $form.on(`change${ns}`, 'input[name="params[pensao_alimenticia]"]', syncPensaoAlimenticia)

  return {
    apply() {
      syncPossuiDependentes() // chama syncPensaoAlimenticia internamente quando necessário
    },
    destroy() { $form.off(ns) }
  }
}
